export const SUPPORTS_OBJECT_FREEZE = "freeze" in Object;
